<video
       [id]="videoId"
       [width]="width"
       [height]="height"
       [poster]="thumbnailUri"
       controls>
</video>
